import React from "react";
import { PayrollCalendarEnddateContainer } from "../../../containers";

const PayrollCalendarEnddate = (props) => {
  return <PayrollCalendarEnddateContainer {...props} />;
};

export default PayrollCalendarEnddate;
